import {createIssueRootCauseAction, updateIssueRootCausesTitleAction} from '../../../app/actions';
import {
  getIssueRootCauseCategoryById,
  getIssueRootCauseCategoryNames,
  getIssueRootCausesNames,
  currentTitleEditedRootCauseId
} from '../../../app/selectors';
import {connect} from '../../../app/connect';
import IssueRootCausesAdminTitle from './IssueRootCausesAdminTitle';

const mapStateToProps = (state, ownProps) => {
  const parent = ownProps.parentId ? getIssueRootCauseCategoryById(state, ownProps.parentId) : null;
  const entity = ownProps.entityId ? getIssueRootCauseCategoryById(state, ownProps.entityId) : null;
  const existingNames = ownProps.parentId
    ? getIssueRootCausesNames(state, parent.childrenIds)
    : getIssueRootCauseCategoryNames(state).concat(getIssueRootCausesNames(state, entity.childrenIds));

  return {
    issueRootCausesNames: existingNames,
    value: ownProps.entityId ? entity.title : '',
    isParent: !ownProps.parentId && !!ownProps.entityId,
    parentStatus: ownProps.parentId ? parent.isActive : null,
    currentTitleEditedRootCauseId: currentTitleEditedRootCauseId(state)
  };
};

const mapDispatchToProps = {
  createIssueRootCauseAction,
  updateIssueRootCausesTitleAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueRootCausesAdminTitle);
